import { EAjaxFunctions } from '@enums';

import { HtmlEntities } from '@utils';

import { AppsByGenreStore, IAppsByGenreStore } from './AppsByGenreStore';
import { AppsStore, IAppsStore } from './AppsStore';
import { AppStore, IAppStoreJSON } from './AppStore';
import { CountersStore, ICountersStore } from './CountersStore';
import { CurrentUserStore, ICurrentUserStoreJSON } from './CurrentUserStore';
import { IMainMenuAppsStoreParams, MainMenuAppsStore } from './MainMenuAppsStore';
import { IShowcaseStore, ShowcaseStore } from './ShowcaseStore';
import { IUiStoreParams, UiStore } from './UiStore';

export * from './AppsStore';
export * from './MainMenuAppsStore';
export * from './AppsByGenreStore';
export * from './CurrentUserStore';
export * from './AppStore';
export * from './UiStore';
export * from './ShowcaseStore';
export * from './CountersStore';

export interface IAppStateJSON {
	mainMenuAppsStore: IMainMenuAppsStoreParams;
	appsInstalledStore: IAppsStore;
	appsByIdStore: IAppsStore;
	appsNewStore: IAppsStore;
	appsPopularStore: IAppsStore;
	appsSalesStore: IAppsStore;
	appStore: IAppStoreJSON;
	showcaseStore: IShowcaseStore;

	appsByGenreStore: IAppsByGenreStore;
	appsByGenreCompilationStore: IAppsByGenreStore;

	currentUser: ICurrentUserStoreJSON;
	uiStore: IUiStoreParams;

	countersStore: ICountersStore;
}

export interface IAppState {
	mainMenuAppsStore: MainMenuAppsStore;
	appsInstalledStore: AppsStore;
	appsByIdStore: AppsStore;
	appsNewStore: AppsStore;
	appsPopularStore: AppsStore;
	appsSalesStore: AppsStore;
	appStore: AppStore;
	showcaseStore: ShowcaseStore;

	appsByGenreStore: AppsByGenreStore;
	appsByGenreCompilationStore: AppsByGenreStore;

	currentUserStore: CurrentUserStore;
	uiStore: UiStore;
	countersStore: CountersStore;

	toJSON(): IAppStateJSON;

	fromJSON(data: IAppStateJSON): void;
}

let appState: IAppState;

export const resetState = () => {
	const appStore = new AppStore();
	const appsInstalledStore = new AppsStore(EAjaxFunctions.APPS_INSTALLED);
	const appsByIdStore = new AppsStore(EAjaxFunctions.APPS_SHOW_BY_ID);
	const appsNewStore = new AppsStore(EAjaxFunctions.APPS_NEW);
	const appsPopularStore = new AppsStore(EAjaxFunctions.APPS_POPULAR);
	const appsSalesStore = new AppsStore(EAjaxFunctions.APPS_SALES);
	const showcaseStore = new ShowcaseStore();
	const appsByGenreStore = new AppsByGenreStore();
	const appsByGenreCompilationStore = new AppsByGenreStore(true);
	const mainMenuAppsStore = new MainMenuAppsStore();
	const currentUserStore = new CurrentUserStore();
	const uiStore = new UiStore();
	const countersStore = new CountersStore();

	appState = {
		mainMenuAppsStore,
		appsInstalledStore,
		appsByIdStore,
		appsNewStore,
		appsPopularStore,
		appsSalesStore,
		appsByGenreCompilationStore,
		appsByGenreStore,
		appStore: appStore,
		showcaseStore,
		currentUserStore,
		uiStore,
		countersStore,

		toJSON(): IAppStateJSON {
			return {
				mainMenuAppsStore: mainMenuAppsStore.toJSON(),
				appsInstalledStore: appsInstalledStore.toJSON(),
				appsByIdStore: appsByIdStore.toJSON(),
				appsNewStore: appsNewStore.toJSON(),
				appsPopularStore: appsPopularStore.toJSON(),
				appsSalesStore: appsSalesStore.toJSON(),
				appsByGenreCompilationStore: appsByGenreCompilationStore.toJSON(),
				appsByGenreStore: appsByGenreStore.toJSON(),
				appStore: appStore.toJSON(),
				showcaseStore: showcaseStore.toJSON(),
				currentUser: currentUserStore.toJSON(),
				uiStore: uiStore.toJSON(),
				countersStore: countersStore.toJSON(),
			};
		},

		fromJSON(data: IAppStateJSON): void {
			this.mainMenuAppsStore.fromJSON(data.mainMenuAppsStore);
			this.appStore.fromJSON(data.appStore),
			this.appsInstalledStore.fromJSON(data.appsInstalledStore);
			this.appsByIdStore.fromJSON(data.appsByIdStore);
			this.appsNewStore.fromJSON(data.appsNewStore);
			this.appsPopularStore.fromJSON(data.appsPopularStore);
			this.appsSalesStore.fromJSON(data.appsSalesStore);
			this.appsByGenreStore.fromJSON(data.appsByGenreStore);
			this.appsByGenreCompilationStore.fromJSON(data.appsByGenreCompilationStore);
			this.showcaseStore.fromJSON(data.showcaseStore);
			this.currentUserStore.fromJSON(data.currentUser);
			this.uiStore.fromJSON(data.uiStore);
			this.countersStore.fromJSON(data.countersStore);
		},
	};
};

export const parseInitialState = () => {
	try {
		appState.fromJSON(JSON.parse(HtmlEntities.decode(document.getElementById('initial-state').innerHTML)));
	} catch (err) {
	}
};

export const getState = () => appState;
export const getCurrentUser = () => appState.currentUserStore.currentUser;
